import request from '@/axios/http'

const BASE = '/stage-api/pre/audition'

export function getCurrentPeriod (preType) {
	return request({
		url: `${BASE}/period/current`,
		method: 'get',
		params: preType ? { preType } : {}
	})
}

export function getLatestPeriod (preType) {
	return request({
		url: `${BASE}/period/latest`,
		method: 'get',
		params: { preType }
	})
}

export function getAdjacentPeriod ({ preType, periodId, direction }) {
	return request({
		url: `${BASE}/period/adjacent`,
		method: 'get',
		params: { preType, periodId, direction }
	})
}

export function listCurrentPeriods () {
	return request({
		url: `${BASE}/period/current/list`,
		method: 'get'
	})
}

export function listEntry (params) {
	return request({
		url: `${BASE}/entry/list`,
		method: 'get',
		params
	})
}

export function getEntryDetail (id) {
	return request({
		url: `${BASE}/entry/${id}`,
		method: 'get'
	})
}

export function createAuditionOrder (entry) {
	return request({
		url: '/stage-api/order/v2/createOrder',
		method: 'post',
		data: {
			money: entry.chargePrice,
			productAuthor: entry.userId,
			productId: entry.productId,
			productSpecsId: entry.productSpecsId,
			payType: 'balancepay',
			productModel: 8,
			quantity: 1,
			title: entry.title || '海选万元实战单',
			uuid: `audition-${entry.id}-${Date.now()}`
		}
	})
}

export function submitEntry (data) {
	return request({
		url: `${BASE}/entry/submit`,
		method: 'post',
		data
	})
}

export function followIntent (entryId) {
	return request({
		url: `${BASE}/follow-intent`,
		method: 'post',
		params: { entryId }
	})
}

export function cancelFollowIntent (entryId) {
	return request({
		url: `${BASE}/follow-intent/cancel`,
		method: 'post',
		params: { entryId }
	})
}

export function getResult (periodId) {
	return request({
		url: `${BASE}/result/${periodId}`,
		method: 'get'
	})
}

export function getChampionTopic (limit = 10) {
	return request({
		url: `${BASE}/champion/topic`,
		method: 'get',
		params: { limit }
	})
}

export function getAuditionPublication (preType) {
	return request({
		url: `${BASE}/governance/publication`,
		method: 'get',
		params: { preType }
	})
}

export function downloadEntry (id) {
	return request({
		url: `${BASE}/entry/${id}/download`,
		method: 'get',
		responseType: 'blob',
		timeout: -1
	})
}

// 海选方案发起众筹招股（跟单意向达阈值后可用）
// 接口：POST /stage-api/pre/audition/crowdfunding/init?entryId=
// Body：CrowdfundingVO(Release 组) —— title/issueNumber/lotteryType/scheme/bettingShopNumber/
//       bettingShopAddress/crowdfundingAmount/crowdfundingNumber/crowdfundingPrice/personLimit
// 注：后端自动回填 auditionEntryId；title/lotteryType 不传则回退为海选方案值。
export function initAuditionCrowdfunding (entryId, data) {
	return request({
		url: `${BASE}/crowdfunding/init`,
		method: 'post',
		params: { entryId },
		data
	})
}
